<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2021-10-12 09:47:12
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-20 09:57:33
-->
<template>
  <div>
    <div class="maintitle" v-if="!isMobile">{{$route.meta.title}}</div>
    <el-divider v-if="!isMobile"></el-divider>
    <el-table :data="list" row-key="id" border>
      <el-table-column prop="name" label="部门"></el-table-column>
      <el-table-column label="负责人点评">
        <template slot-scope="scope">
          <span>{{formatExcellent(scope.row.tempexcellent)}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="最终得分" prop='score'></el-table-column> -->
      <el-table-column label="投票" :formatter="formatVote"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button-group>
            <el-button @click="ass(scope)" size='mini'>查看</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title='crntemployee' :visible.sync="assDiv" :show-close="false" width='100%' :close-on-click-modal="false">
      <el-form label-width="100px" v-if="isMobile">
        <div v-for="(item,index) in info" :key="index" class="kaohe-item-mobile">
          <el-form-item v-for="(it,id) in trList" :key="id" :label="it.label" v-if="item[it.prop]!== ''">
            <div class="kaohe-item-mobile-detail">
              <span v-html="item[it.prop]" v-if="it.html===1"></span>
              <span v-else>{{ item[it.prop] }}</span>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <el-table :data="info" row-key="id" border width="100%" v-else>
        <el-table-column v-for="(item,index) in trList" :key="index" :label="item.label" :width="item.width" :fixed="item.fixed" :align="item.align">
          <template slot-scope="scope">
            <span v-html='scope.row[item.prop]' v-if="item.html==1"></span>
            <span v-else>{{ scope.row[item.prop] }}</span>
            <!-- <template v-else>
              <el-input v-model='scope.row[item.prop]' v-if="item.edit==1 && scope.row.readonly!=1" :type="item.type"></el-input>
              <span v-html='scope.row[item.prop]'></span>
            </template> -->
          </template>
        </el-table-column>
      </el-table>
      <div v-if="isMobile">
        <div v-for="(item,index) in excellentlist" :key="index" class="kaohe-item-mobile">
          <p v-html="item.standard" style="font-weight: bold;text-align: left"></p>
          <el-form label-width="100px">
            <div v-for="(it,id) in shenheList" :key="id">
              <div v-if="id!=='final'">
                <el-form-item :label="it.name">
                  <div class="kaohe-item-mobile-detail" v-html="getBeizhu(item.detail, it.uuid)"></div>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <el-form label-width="100px" class="kaohe-item-mobile">
          <div v-for="(it,id) in shenheList" :key="id">
            <el-form-item :label="it.name" v-if="it.uuid!=='final'">
              <div class="kaohe-item-mobile-detail">{{ getExcellent(it.uuid) }}</div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <table class="excellent-table" v-else>
        <tr>
          <th style='width:300px;'>优秀标准</th>
          <th v-for="(item,index) in shenheList" :key="index" style="min-width: 200px;">
            {{ item.name }}
          </th>
        </tr>
        <tr v-for='(item,index) in excellentlist' :key='item.id' :index='index'>
          <td v-html="item.standard" class="text-left"></td>
          <td v-for="(it,i) in shenheList" :key="i">
            <span v-if="i!='final'" v-html="getBeizhu(item.detail,it.uuid)"></span>
          </td>
        </tr>
        <tr>
          <td>评选结果</td>
          <td v-for="(item,index) in assessinfo.detail" :key="index">
            {{formatExcellent(item.excellent)}}
          </td>
        </tr>
      </table>
      <el-divider></el-divider>
      <div class="margin-top text-left">
        已投票人数{{ voted }}人，{{num}}人同意，<span style="color:red">{{fnum}}</span>人不同意
        <div v-if="fnum != 0">不同意理由为. 
          <p v-for = "(item,index) in fdetail" :key="index">{{index+1}}: {{item}}</p>
        </div>
      </div>
      <div class="margin-top" v-if="assessinfo.status != 9">
        是否同意最终负责人意见：
        <el-radio-group v-model="voteInfo.result" size="mini">
          <el-radio-button label="1">同意</el-radio-button>
          <el-radio-button label="0">不同意</el-radio-button>
        </el-radio-group>
      </div>
      <div class="margin-top">
        <el-input type='textarea' v-model='voteInfo.beizhu' placeholder="请填写理由" :readonly="assessinfo.status == 9?true:false"></el-input>
      </div>
      <div class="margin-top">
        <el-button @click="submit" size='mini'>提交</el-button>
        <el-button @click="assDiv=false" size='mini'>返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //考核员工列表
      keyword: '',
      excellentTypeList: JSON.parse(sessionStorage.getItem('excellentType')),
      info: [],
      assessinfo: {},
      assDiv: false,
      month: '',
      crntemployee: '',
      excellentlist: [],
      trList: [],
      canRefuse: 0,
      shenheList: {},
      uuid: sessionStorage.getItem('employeeuuid'),
      voteInfo: {
        result: 1,
        beizhu: '',
        id: 0
      },
      voted:0,
      num:0,
      fnum:0,
      fdetail:[]
    };
  },
  computed: {},
  methods: {
    getlist() {
      this.$axios({
        url: this.HOST + "/kaohe/vote/getDepList",
        method: "post",
        data: {},
      }).then((res) => {
        this.list = res.data.list;
      });
    },
    formatExcellent(e) {
      if (e == -1) return;
      for (let i in this.excellentTypeList) {
        if (this.excellentTypeList[i].excellent_id == e) return this.excellentTypeList[i].excellent_title;
      }
      return '不评';
    },
    formatVote(row, column) {
      switch (row.result) {
        case 0:
          return '不同意';
        case 1:
          return '同意';
        default:
          return '未投票';
      }
    },
    getBeizhu(item, uuid) {
      return item[uuid]?(item[uuid].beizhu===''?'<span style="color:#999">未填写</span>':item[uuid].beizhu):'<span style="color:#999">无内容</span>';
    },
    ass(scope) {
      this.$axios({
        url: this.HOST + "/kaohe/vote/getAssByAid",
        method: "post",
        data: {
          id: scope.row.id,
          isVote: 1
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.info = res.data.list;
          this.assessinfo = res.data.assinfo;
          for (let item in this.assessinfo.detail) {
            this.assessinfo.detail[item].excellent = parseInt(this.assessinfo.detail[item].excellent)
          }
          this.assDiv = true;
          this.needExcellent = res.data.needExcellent;
          this.crntemployee = scope.row.name;
          this.excellentlist = res.data.excellentlist;
          this.trList = res.data.trList;
          this.canRefuse = res.data.canRefuse;
          this.shenheList = res.data.shenheList;
          this.voteInfo = res.data.vote;
          this.num = res.data.num;
          this.fnum = res.data.fnum;
          this.fdetail = res.data.fdetail;
          this.voted = res.data.voted;
        }
      });
    },
    submit() {
      if (this.voteInfo.result === 0 && this.voteInfo.beizhu === '') {
        this.$message({
          type: 'error',
          message: '不同意最终负责人意见时必须填写理由'
        })
        return;
      }
      this.$axios({
        url: this.HOST + '/kaohe/vote/employeeSub',
        method: 'post',
        data: {
          id: this.assessinfo.id,
          info: this.voteInfo
        }
      }).then(res => {
        if (res.data.status === 1) {
          this.$message({
            type: 'success',
            message: res.data.info
          })
          this.assDiv = false
          this.getlist()
        }
      })
    },
    getExcellent(uuid) {
      const temp = this.assessinfo.detail.filter(item => {
        return item.uuid === uuid;
      })
      return temp.length > 0 ? this.formatExcellent(temp[0].excellent) : '';
    }
  },
  created: function () {
    this.getlist();
  },
};
</script>